
export const SET_THEME = 'SET_THEME';
export const TOGGLE_THEME = 'TOGGLE_THEME';
export const SET_THEME_VARIANT = 'SET_THEME_VARIANT';


export const setTheme = (theme) => ({
  type: SET_THEME,
  payload: theme
});

export const toggleTheme = () => ({
  type: TOGGLE_THEME
});

export const setThemeVariant = (variant) => ({
  type: SET_THEME_VARIANT,
  payload: variant
}); 